import { render, staticRenderFns } from "./CartBill.vue?vue&type=template&id=61050d63&scoped=true&"
import script from "./CartBill.vue?vue&type=script&lang=js&"
export * from "./CartBill.vue?vue&type=script&lang=js&"
import style0 from "./CartBill.vue?vue&type=style&index=0&id=61050d63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61050d63",
  null
  
)

export default component.exports